const ADD_ADDRESS = "ADD_ADDRESS";
const ADD_PLACE = "ADD_PLACE";
const ADD_ROOMS = "ADD_ROOMS";
const ADD_DATA = "ADD_DATA";
const ADD_SELECTED_ROOMS = "ADD_SELECTED_ROOMS";

export { ADD_ADDRESS, ADD_DATA, ADD_PLACE, ADD_ROOMS, ADD_SELECTED_ROOMS };
